import type { FetchMetadataProps } from '../createMetadataFetcher';
import { createMetadataFetcher } from '../createMetadataFetcher';
import { getOrigin } from '../getOrigin';

// https://sc-mirror.shoutca.st/docs/DNAS_Server_XML_Responses.html#7.html
const SONG_TITLE_INDEX_FULL = 6;
const SONG_TITLE_INDEX_SHORT = 4;

export const fetchSevenHTML = async ({
  url,
  ...forwardingProps
}: FetchMetadataProps) => {
  return createMetadataFetcher({
    ...forwardingProps,
    url: `${getOrigin(url)}/7.html`,
    parser: async (response) => {
      const text = await response.text();
      const [htmlContent] = text.match(/(.*?)<\/body>/gi) ?? [];
      const [, , metadataMatch] =
        htmlContent?.match(/(<body>|,)(.*)<\/body>/i) ?? [];
      const metadata = metadataMatch.split(',');

      return metadata.length === 7
        ? metadata[SONG_TITLE_INDEX_FULL]
        : metadata[SONG_TITLE_INDEX_SHORT];
    }
  });
};
